import { useState } from 'react';

const JOB_POLLING_INTERVAL_MS = 10 * 1000;

export const useJobPollingInterval = () => {
  const [pollingActive, setPollingActive] = useState<boolean>(false);

  const pollingInterval = pollingActive ? JOB_POLLING_INTERVAL_MS : undefined;

  return { pollingInterval, pollingActive, setPollingActive };
};
